import SignupCharacterUsernameStep from "./SignupCharacterUsernameStep.vue";
import SignupEmailStep from "./SignupEmailStep.vue";
import SignupPasswordStep from "./SignupPasswordStep.vue";
import SignupReferralStep from "./SignupReferralStep.vue";
import SignupTopupStep from "./SignupTopupStep.vue";
import SignupDownloadStep from "./SignupDownloadStep.vue";
import { ref, watch } from "vue";

export const ignoreDownloadStep = ref<boolean>(
  Boolean(localStorage.getItem("ignoreDownloadStep")),
);

watch(
  ignoreDownloadStep,
  (d) => {
    localStorage.setItem("ignoreDownloadStep", JSON.stringify(d));
  },
  {
    immediate: true,
  },
);

export default {
  SignupCharacterUsernameStep,
  SignupEmailStep,
  SignupPasswordStep,
  SignupReferralStep,
  SignupTopupStep,
};
export const SignupStepsNoReferral = {
  SignupCharacterUsernameStep,
  SignupEmailStep,
  SignupPasswordStep,
  SignupTopupStep,
};
export const OptionalSignupSteps = {
  SignupTopupStep,
  SignupDownloadStep,
};
export const MobileSignupSteps = {
  SignupCharacterUsernameStep,
  SignupEmailStep,
  SignupPasswordStep,
  SignupTopupStep,
  SignupDownloadStep,
};
